import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=0839ba42"
import script from "./FormView.vue?vue&type=script&lang=ts"
export * from "./FormView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports